// @givmo/app-admin — the signed-in person's role line in the sidebar's account card (D-EP-77, Jonathan
// 2026-10-24 17:17: "If the signed in person is a global admin, it should say global admin. if htey
// are not a global admin but they are an owner of the module they are in, then it should say Owner.
// if they are not a global admin and are a member of the module they are in, it should say member.").
//
// The portal IS the Donations module (`employer`), so "the module they are in" is Donations, and the
// level is read off the standing read the shell already makes (`GET /admin/company/me`):
// `is_global_admin`, then `product_access.employer.granted_role`. Never the wire's base role alone:
// a regular admin who is a Donations Owner holds the base role "Member".
//
// ⚠ THE LEVEL COUNTS ONLY WHERE THEY HOLD DONATIONS (`has_access`). The read serves a `granted_role`
// for every app, held or not: a regular admin given only Campaigns reads Donations as "Member" with
// `has_access: false`. They are no member of Donations, so the card says no level, as the console's
// own standing decoder reads an app held only on `has_access === true` (`standingsFromAccessBag`).

import type { AdminOut } from '@givmo/api-client';
import { GLOBAL_ADMIN_LABEL, MEMBER_LABEL, moduleTierLabel } from '@givmo/org-console';

/** The Donations module's slug on the wire. */
const DONATIONS = 'employer';

/**
 * "Global Admin", or the person's Donations level ("Owner" or "Member"), or `null` when the read
 * cannot say one: no read yet, or a regular admin who holds no Donations or has no level served.
 */
export function accountRoleLine(me: AdminOut | null | undefined): string | null {
  if (me == null) return null;
  if (me.is_global_admin === true) return GLOBAL_ADMIN_LABEL;
  if (me.is_global_admin === false) {
    const donations = me.product_access?.[DONATIONS];
    if (donations?.has_access !== true) return null;
    const level = donations.granted_role;
    return typeof level === 'string' && level.trim().length > 0 ? moduleTierLabel(level) : null;
  }
  // A standing read without the field (a backend before EP-SUITE3) has only the wire's company role,
  // whose Owner is the company-wide Global Admin.
  const role = me.admin_company_role?.trim();
  return role === 'Owner' ? GLOBAL_ADMIN_LABEL : role === 'Member' ? MEMBER_LABEL : null;
}
